module.exports = __webpack_public_path__ + "img/2.c923328b.jpg";